import { TabPanel } from '@mui/lab';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { Protect } from 'app/components';
import { MapTransportSynchronizedChart } from 'app/pages/Map';
import React from 'react';

const TabPanelChart = ({ isFetchConditionLoading, transportSelectedItem, transportConditionItems }) => {
  const isFuelTank = transportSelectedItem.type_id === 6;
  return (
    <TabPanel value='chart'>
      {['onlyWialon'].includes(config.transportDeviceTypes[transportSelectedItem.device_type]) ? (
        <React.Fragment>
          <Stack
            direction='column'
            alignItems='center'
            justifyContent='center'
            sx={(theme) => ({
              width: '100%',
              height: '100%',
              padding: theme.spacing(2),
            })}>
            <Typography align='center' variant='body1' component='span'>
              Раздел недоступен
            </Typography>
            <Typography align='center' color='text.secondary' variant='caption' component='span'>
              Для текущего типа транспортного средства раздел недоступен
            </Typography>
          </Stack>
        </React.Fragment>
      ) : (
        <Protect
          permissions='read'
          renderPermitted={() => (
            <React.Fragment>
              {!isFetchConditionLoading && transportConditionItems.length !== 0 && (
                <Stack
                  direction='row'
                  sx={(theme) => ({
                    height: '100%',
                    bgcolor: 'background.default',
                    borderTop: '1px solid',
                    borderColor: theme.palette.divider,
                  })}>
                  <MapTransportSynchronizedChart isFuelTank={isFuelTank} />
                </Stack>
              )}
              {!isFetchConditionLoading && transportConditionItems.length === 0 && (
                <Stack
                  direction='column'
                  alignItems='center'
                  justifyContent='center'
                  sx={(theme) => ({
                    width: '100%',
                    height: '100%',
                    padding: theme.spacing(2),
                  })}>
                  <Typography align='center' variant='body1' component='span'>
                    Здесь пока ничего нет
                  </Typography>
                  <Typography align='center' color='text.secondary' variant='caption' component='span'>
                    В этом разделе будут находиться графики транспортного средства
                  </Typography>
                </Stack>
              )}
              {isFetchConditionLoading && (
                <Stack
                  direction='column'
                  alignItems='center'
                  justifyContent='center'
                  sx={(theme) => ({
                    width: '100%',
                    height: '100%',
                    padding: theme.spacing(2),
                  })}>
                  <CircularProgress size={24} />
                </Stack>
              )}
            </React.Fragment>
          )}
          renderForbidden={() => (
            <React.Fragment>
              <Stack
                direction='column'
                alignItems='center'
                justifyContent='center'
                sx={(theme) => ({
                  width: '100%',
                  height: '100%',
                  padding: theme.spacing(2),
                })}>
                <Typography align='center' variant='body1' component='span'>
                  Доступ ограничен
                </Typography>
                <Typography align='center' color='text.secondary' variant='caption' component='span'>
                  Под вашей учетной записью доступ ограничен
                </Typography>
              </Stack>
            </React.Fragment>
          )}
        />
      )}
    </TabPanel>
  );
};
export default TabPanelChart;
